// libs
import { styled } from '@nykaa/ui-components';

// constants
import { FONTS, DWEB_MAX_WIDTH } from 'shared/styles/base';

// styles
export const Container = styled.div`
  max-width: ${DWEB_MAX_WIDTH}px;
  margin: ${({ theme }) => `${theme.spacing.spacing100} auto ${theme.spacing.spacing320}`};
  padding: 0;
  position: relative;
  display: flex;
  justify-content: flex-start;
`;

export const Images = styled.section`
  display: flex;
  width: 58.33%;
  padding: ${({ theme }) => `0 ${theme.spacing.spacing80}`};
`;

export const Thumbnails = styled.ul`
  width: 99px;
  margin-right: ${({ theme }) => theme.spacing.spacing160};
  display: flex;
  flex-flow: column;
  list-style: none;
  padding: 0;
`;

export const Thumbs = styled.li`
  background: #f4f4f4;
  width: 99px;
  height: 132px;
  margin-bottom: 37px;
`;

export const MainImage = styled.div`
  width: 503px;
  height: 670.66px;
  background: #f4f4f4;
`;

export const Details = styled.section`
  display: flex;
  flex-flow: column;
  width: 40%;
  padding-top: ${({ theme }) => theme.spacing.spacing50};
`;

export const Line = styled.div`
  background: #f4f4f4;
  display: block;
  height: 13px;
  margin-bottom: ${({ theme }) => theme.spacing.spacing50};
`;

export const Title = styled(Line)`
  width: 40px;
`;

export const SubTitle = styled(Line)`
  width: 200px;
`;

export const Price = styled(Line)`
  margin-top: ${({ theme }) => theme.spacing.spacing50};
  width: 80px;
`;

export const ShimmerLine = styled(Line)`
  width: 150px;
  margin-top: ${({ theme }) => theme.spacing.spacing240};
`;

export const Button = styled.div`
  text-transform: uppercase;
  display: flex;
  color: #fff;
  text-align: center;
  padding: ${({ theme }) => `${theme.spacing.spacing60} 0`};
  font: 700 16px/1 ${FONTS.BASE_FAMILY};
  background: #888;
  display: block;
  width: 150px;
  margin-top: ${({ theme }) => theme.spacing.spacing240};
`;
